export const STORAGE_KEY_OAUTH_DATA = 'oauth_connection_data';
